import { render, staticRenderFns } from "./MotionSearchView.vue?vue&type=template&id=1c27345e&"
import script from "./MotionSearchView.vue?vue&type=script&lang=ts&"
export * from "./MotionSearchView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports